import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AiAnalysis, AiAnalysisResponse, AiApplyDecisionsResponse, AiExportResponse, AiImproveResponse, AiPromptsResponse, Language} from './ai-profile-matching.model';

@Injectable({providedIn: 'root'})
export class AiProfileMatchingService {
  private profilerApiUrl = environment.apiConfig.uri;

  constructor(private http: HttpClient) {
  }

  getAiExport(consultantId: string): Observable<AiExportResponse> {
    return this.http.get<AiExportResponse>(`${this.profilerApiUrl}api/berater/${consultantId}/ai-export`);
  }

  getPrompts(): Observable<AiPromptsResponse> {
    return this.http.get<AiPromptsResponse>(`${this.profilerApiUrl}api/ai/prompts`);
  }

  analyze(consultantId: string, sanitizedProfile: string, job: string, language: Language,
          promptOverrides?: Record<string, string>): Observable<AiAnalysisResponse> {
    return this.http.post<AiAnalysisResponse>(`${this.profilerApiUrl}api/berater/${consultantId}/ai-analyze`, {
      sanitizedProfile,
      job,
      language,
      promptOverrides
    });
  }

  improve(consultantId: string, profile: string, job: string, analysis: AiAnalysis,
          language: Language, promptOverrides?: Record<string, string>): Observable<AiImproveResponse> {
    return this.http.post<AiImproveResponse>(`${this.profilerApiUrl}api/berater/${consultantId}/ai-improve`, {
      profile,
      job,
      analysis,
      language,
      promptOverrides
    });
  }

  applyDecisions(consultantId: string, originalProfile: string, improvedProfile: string,
                 decisions: Record<string, boolean>): Observable<AiApplyDecisionsResponse> {
    return this.http.post<AiApplyDecisionsResponse>(
      `${this.profilerApiUrl}api/berater/${consultantId}/ai-apply-decisions`,
      {originalProfile, improvedProfile, decisions}
    );
  }
}
